<template>
  <ConfigProvider :locale="locale">
    <div id="app">
      <router-view/>
    </div>
  </ConfigProvider>
</template>
<script>
import { ConfigProvider } from 'ant-design-vue'
import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN'
import { mapActions } from 'vuex'
export default {
  components: {
    ConfigProvider,
  },
  data () {
    return {
      locale: zh_CN,
    }
  },
  methods: {
    ...mapActions([
      'connectNIM',
      'closePhotoDialog'
    ]),
  },
  async beforeUpdate () {
    if (this.$route.name !== 'login') {
      await this.connectNIM()
    }
  },
  beforeDestroy() {
    this.closePhotoDialog()
  }
}
</script>
<style lang="less">
@import url('./style/common/reset.less');
@import url('./style/common/variable.less');
@import url('./style/common/antd.less');
#app{
  font-size: 14px;
  height: 100%;
  background-color: @pageBgColor;
}
</style>
